import Swiper, { Pagination } from 'swiper';
import 'swiper/css';

window.addEventListener('load', (e) => {
	const productSwiper = document.querySelector('.awards-swiper');

	if (productSwiper) {
		const prodSlider = new Swiper(productSwiper, {
			modules: [Pagination],
			spaceBetween: 20,
			slidesPerView: 1.1,
			edgeSwipeThreshold: 60,
			preventClicks: false,
			shortSwipes: false,
			a11y: false,
			watchSlidesProgress: true,
			noSwipingSelector: '.toggle',
			pagination: {
				el: productSwiper.querySelector('.swiper-pagination'),
				clickable: true,
			},
			breakpoints: {
				860: {
					slidesPerView: 2.2,
					slidesPerGroup: 2,
				},
				1160: {
					slidesPerView: 3,
					slidesPerGroup: 3,
				},
			},
		});
	}
});

const contentToggle = document.querySelectorAll(
	'.awards-swiper .swiper-slide .toggle'
);
contentToggle.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		let slide = toggle.closest('.swiper-slide');
		slide.classList.toggle('content-active');
		toggle.classList.toggle('active');
		// let toggleText = toggle.textContent;
		// toggle.textContent = toggleText == '+' ? '-' : '+';
	});
});
